export default (() => {
  const getContentDispositionHeader = response => {
    const disposition = response.headers.get('content-disposition');

    if (hasValue(disposition) === false) throw new Error('content-disposition header not found');

    if (disposition.indexOf('attachment') === -1)
      throw new Error('attachment in content-disposition header not found');

    return disposition;
  };
  const parseHeaderToGetFileName = contentDispositionHeader => {
    let filename = '';

    if (hasValue(contentDispositionHeader)) {
      const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      const matches = filenameRegex.exec(contentDispositionHeader);

      if (matches != null && matches[1]) filename = matches[1].replace(/['"]/g, '');
    }

    return filename;
  };
  const openFileLink = (file, fileName) => {
    const anchorUrl = window.URL.createObjectURL(file);

    const link = document.createElement('a');
    link.href = anchorUrl;
    link.setAttribute('download', fileName);

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const hasValue = value => {
    return value !== null && typeof value !== 'undefined';
  };

  // get a survey id string (e.g. #6_survey_9_9_1) and return the right parts
  // {instrumentId: 6, questionId: 9_9_1}
  const extractIdsFromSurveyIdString = surveyIdString => {
    let parts = surveyIdString.split('#');
    const instrumentId = parts[0];
    const questionId = parts[1].replace('survey-', '');

    return {
      questionId,
      instrumentId: parseInt(instrumentId)
    };
  };

  const orderStatuses = {
    created: {
      step: 0
    },
    questionnaire_completed: { step: 1 },
    profiled: { step: 2 },
    no_offers: { step: 3 },
    offers: { step: 4 },
    offer_chosen: { step: 4 },
    contract_proposal_needed: { step: 5 },
    contract_proposal_sent: { step: 6 },
    approval_neeeded: { step: 7 },
    approved: { step: 8 },
    policies_needed: { step: 9 },
    paid_failed: { step: 9 },
    policies_emitted: { step: 10 },
    active: { step: 11 }
  };

  const FREEZED_ORDER_STATUSES = [
    'approved',
    'paid_failed',
    'policies_needed',
    'policies_emitted',
    'active',
    'canceled'
  ];

  return {
    saveFile: async response => {
      const contentDispositionHeader = getContentDispositionHeader(response);
      const fileName = parseHeaderToGetFileName(contentDispositionHeader);

      const fileData = await response.blob();
      openFileLink(fileData, fileName);
    },
    extractIdsFromSurveyIdString,
    orderStatuses,
    FREEZED_ORDER_STATUSES
  };
})();
